import {Component, Inject, OnInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {BaseModalComponent} from '../base-modal/base-modal.component';
import {ErrorHandlingService} from '../../services/error-handling.service';
import {HistoryService} from '../../services/history.service';
import {MapService} from '../../services/map.service';
import {ToastService} from '../../services/toast.service';
import {FormsModule} from '@angular/forms';

@Component({
    selector: 'app-notes-modal',
    templateUrl: './notes-modal.component.html',
    styleUrls: ['./notes-modal.component.css'],
    imports: [
        FormsModule
    ]
})
export class NotesModalComponent extends BaseModalComponent {
  constructor(http: HttpClient, toastService: ToastService, errorHandling: ErrorHandlingService,
              activeModal: NgbActiveModal, mapService: MapService, history: HistoryService,
              @Inject('environment') private e) {
    super(http, toastService, errorHandling, activeModal, mapService, history, e);
  }
}
